import React from "react";
import { Calendar, Heart, Clock, FileText, CheckCircle2 } from "lucide-react";

export default function UnifiedTimeline({ events = [] }) {
  if (!events || events.length === 0) {
    return <div className="text-gray-500 text-sm italic py-4">No activity logged yet.</div>;
  }

  const getEventIcon = (type) => {
    switch (type) {
      case "DONATION":
        return <Heart className="w-4 h-4 text-emerald-500" />;
      case "EVENT_ATTENDANCE":
        return <Calendar className="w-4 h-4 text-blue-500" />;
      case "HOURS_LOGGED":
        return <Clock className="w-4 h-4 text-purple-500" />;
      case "AID_DISBURSED":
        return <CheckCircle2 className="w-4 h-4 text-amber-500" />;
      default:
        return <FileText className="w-4 h-4 text-slate-500" />;
    }
  };

  return (
    <div className="relative pl-6 space-y-6 before:absolute before:left-2 font-sans before:top-2 before:bottom-2 before:w-0.5 before:bg-slate-200">
      {events.map((evt, idx) => (
        <div key={idx} className="relative group">
          <div className="absolute -left-6 top-1 w-4 h-4 rounded-full bg-white border-2 border-slate-300 flex items-center justify-center group-hover:border-indigo-600 transition-colors">
            {getEventIcon(evt.event_type)}
          </div>
          <div className="bg-slate-50 p-3.5 rounded-xl border border-slate-200/80 shadow-sm">
            <div className="flex items-center justify-between gap-2">
              <h4 className="text-sm font-semibold text-slate-900">{evt.title}</h4>
              <span className="text-xs text-slate-500 font-mono">
                {new Date(evt.timestamp).toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                })}
              </span>
            </div>
            {evt.description && (
              <p className="text-xs text-slate-600 mt-1 leading-relaxed">{evt.description}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
